let contact_name = null;
let contact_email = null;
let contact_company = null;
let contact_mobile = null;
let contact_req = null;
let isValid = false;

function activateEnquiry(contactFrom) {
  document.querySelector("#btn_subscribe").addEventListener("click", () => {
    contact_name = String(document.getElementById("contact_name").value);
    contact_email = String(document.getElementById("contact_email").value);
    contact_company = String(document.getElementById("contact_company").value);
    contact_mobile = String(document.getElementById("contact_mobile").value);
    contact_req = String(document.getElementById("contact_requirement").value);
    isValid = true;

    $("input#contact_name").removeClass("error");
    $("input#contact_email").removeClass("error");
    $("input#contact_company").removeClass("error");
    $("input#contact_mobile").removeClass("error");
    $("textarea#contact_requirement").removeClass("error");
    if (contact_name.length <= 0) {
      $("input#contact_name").addClass("error");
      isValid = false;
    }
    if (!isNaN(contact_name)) {
      $("input#contact_name").addClass("error");
      isValid = false;
    }
    if (contact_company.length <= 0) {
      $("input#contact_company").addClass("error");
      isValid = false;
    }
    if (contact_email.length <= 0) {
      $("input#contact_email").addClass("error");
      isValid = false;
    }

    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var m = re.test(contact_email);
    if (!m) {
      $("input#contact_email").addClass("error");
      isValid = false;
    }

    if (contact_mobile.length > 0 && isNaN(contact_mobile)) {
      $("input#contact_mobile").addClass("error");
      isValid = false;
    }
    if (!isValid) {
      return false;
    } else {
      //   Global.enquirySubmitted = true;
    }

    var data = $("#enquiry_form").serializeArray();
    // console.log(data);
    data.push({ name: "contact_from", value: contactFrom });
    // $.post("page.php", data);
    $.ajax({
      url: "https://snamabrasivesltd.com/snam_vietnam_enq.php",
      type: "POST",
      data: data,
      success: function (result) {
        console.log(result);
      },
    });

    $(".enquiry_sec ").removeClass("active");
    $("#btn_subscribe").css("opacity", "0");
    $(".enquiry_sec .sec1").removeClass("active");
    $(
      ".user_data_sec .field1, .user_data_sec .field2, .user_data_sec .field3, .user_data_sec .field4,.user_data_sec .field5"
    ).addClass("active");
    $(".user_data_sec").css("opacity", "0");
    setTimeout(function () {
      setTimeout(function () {
        $(".thank-sec .row span").addClass("active");
      }, 0);
    }, 650);
  });
}
export { activateEnquiry };
